import { orderBy } from "lodash";
import { DataProvider } from "react-admin";
import { getRouteService } from "utils/tools";

export const colors = [
  "#AD1457",
  "#00796B",
  "#E65100",
  "#01579B",
  "#1B5E20",
  "#6A1B9A",
  "#B71C1C",
  "#00B8D4",
  "#BF360C",
  "#FF6633",
  "#FFB399",
  "#FF33FF",
  "#FFFF99",
  "#00B3E6",
  "#E6B333",
  "#3366E6",
  "#999966",
  "#99FF99",
  "#B34D4D",
  "#80B300",
  "#809900",
  "#E6B3B3",
  "#6680B3",
  "#66991A",
  "#FF99E6",
  "#CCFF1A",
  "#FF1A66",
  "#E6331A",
  "#33FFCC",
  "#66994D",
  "#B366CC",
  "#4D8000",
  "#B33300",
  "#CC80CC",
  "#66664D",
  "#991AFF",
  "#E666FF",
  "#4DB3FF",
  "#1AB399",
  "#E666B3",
  "#33991A",
  "#CC9999",
  "#B3B31A",
  "#00E680",
  "#4D8066",
  "#809980",
  "#E6FF80",
  "#1AFF33",
  "#999933",
  "#FF3380",
  "#CCCC00",
  "#66E64D",
  "#4D80CC",
  "#9900B3",
  "#E64D66",
  "#4DB380",
  "#FF4D4D",
  "#99E6E6",
  "#6666FF",
  "#FF80E6",
  "#003366",
  "#669999",
  "#006666",
  "#CCCCCC",
  "#00CCFF",
  "#993300",
  "#66CCCC",
  "#FF99CC",
  "#FFCC99",
  "#FFFF1A",
  "#00FF99",
];

const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

export const renderRoutePolyline = async (routes: any, token: string) => {
  let tempRoutes: any = [];

  await Promise.all(
    routes.map(async (route: any) => {
      await delay(2000);
      const getRoute = await getRoutePolyline(route.routeLocations, token).then(
        (result) => {
          result.color = route.color;

          return result;
        }
      );

      tempRoutes.push(getRoute);
    })
  );

  return tempRoutes;
};

const getRoutePolyline = async (locations: any, token: string) => {
  try {
    let tempRouteLocations: any = [];
    let routeLocations: any = [];

    await Promise.all(
      locations.map(async (marker: any, index: number) => {
        if (index < locations.length - 1) {
          const start = locations[index];
          const end = locations[index + 1];

          const routeResults = await getRouteService(start, end, token).then(
            (result: any) => {
              result.index = index;
              return result;
            }
          );

          tempRouteLocations.push(routeResults);
          const sortedRouteLocationsByIndex = orderBy(
            tempRouteLocations,
            ["index"],
            ["asc"]
          );

          routeLocations = [...routeLocations, ...sortedRouteLocationsByIndex];
        }
      })
    );

    return routeLocations;
  } catch (e) {
    setTimeout(() => {
      console.log(`GOT ERROR: ${e}, Re-fetch again.`);
      getRoutePolyline(locations, token);
    }, 3000);
  }
};

// props for tab menu
export const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

export const getStudents = async (levelId: Number, provider: DataProvider) => {
  return await provider
    .getList("students", {
      filter: {
        LevelId: levelId,
        Status: "active",
      },
      pagination: {
        page: 1,
        perPage: 9999,
      },
      sort: {
        field: "Id",
        order: "ASC",
      },
    })
    .then((result) => {
      return result.data;
    });
};

export const getStudentAddressesByStudentIds = async (
  studentIds: Number[],
  provider: DataProvider
) => {
  return await provider
    .getList("studentAddresses", {
      filter: { StudentIds: studentIds },
      pagination: {
        page: 1,
        perPage: 1000,
      },
      sort: {
        field: "Id",
        order: "ASC",
      },
    })
    .then((result) => {
      return result.data;
    });
};

export const DriversResources = async (
  ids: number[],
  provider: DataProvider
) => {
  return await provider
    .customGetListWithStaticParams(`drivers?ids=${ids}`)
    .then((result: any) => {
      return result.data;
    });
};

export const BusAssistanResources = async (
  ids: number[],
  provider: DataProvider
) => {
  return await provider
    .customGetListWithStaticParams(`busAssistants?ids=${ids}`)
    .then((result: any) => {
      return result.data;
    });
};

export const VehiclesResources = async (
  ids: number[],
  provider: DataProvider
) => {
  return await provider
    .customGetListWithStaticParams(`vehicles?ids=${ids}`)
    .then((result: any) => {
      return result.data;
    });
};
